import React from 'react';
const navBarStyle = {
  backgroundColor: "red",
  color: "white",
  width: "100%",
  height: "60px",
};

export const NavBar = () => (
  <div className="NavBar" style={navBarStyle}>
    NAVBAR
  </div>
);
